angular.module(NgAppName).directive('crSideContact', ['$http', '$window', '$compile', '$timeout', '$cookies', '$animate', '$interval',
function($http, $window, $compile, $timeout, $cookies, $animate, $interval) {
	return {
		restrict: 'A',
		replace: true,
		scope: true,

		link: function(scope, element, attrs) {
			var _contactContent = angular.element(element[0].querySelector('.w_side_contact_content'));
			var _contactInfos = angular.element(element[0].querySelectorAll('.w_side_contact_content .contact_info'));
			var _formContainer = angular.element(element[0].querySelector('.w_side_contact_content .form_container'));
			var _formContentWrapper = angular.element(element[0].querySelector('.w_side_contact_content .form_container .wrapper'));
			var _defaultContent = angular.element(element[0].querySelector('.w_side_contact .default_content'));
			var _contactVeil = angular.element(element[0].querySelectorAll('.w_side_contact .veil'));

			scope.eventCategory = attrs.eventCategory;

			scope.user = {};
			scope.errorMessages = {
				required: 'This field is required.',
				phoneExist: 'This phone already exists.',
				phoneFormat: 'This phone number is not valid.',
				phoneShort: 'This phone is too short (less than 6 characters).',
				phoneLong: 'This phone is too long (more than 15 characters).'
			};

			// track side contact loaded
			if (scope.eventCategory) {
				_gaq.push(['_trackEvent', scope.eventCategory, 'load', '']);
			}

			var __getContent = function() {
				if (_contactContent.parent().hasClass('hidden')) {
					_contactContent.parent().remove();
				}

				scope._button = angular.element(element[0].querySelector('.w_side_contact .button'));
				scope._buttons = angular.element(element[0].querySelectorAll('.w_side_contact .button'));
				scope._content = angular.element(element[0].querySelector('.w_side_contact_content'));
				scope.contactType = angular.element(_contactInfos[0]).attr('data-contact-type');
				scope.onDefaultFormState = _contactInfos.length === 1 && (scope.contactType === 'default' || scope.contactType === 'csr');
				scope.onListingPopup = attrs.onListingPopup;

				_contactVeil.addClass('none');
			};

			var __setAnimationCounts = function() {
				var cookie = $cookies.get('crSideContactAnimationCounts');
				var animationCounts = 1;
				var date = new Date();

				if (cookie) {
					cookie = JSON.parse(cookie, false);
					animationCounts = cookie.value.toInt() + 1;
				}

				if (animationCounts > 1 && animationCounts <= 3) {
					var value = {
						value: animationCounts,
						expirationDate: cookie.expirationDate
					};

					$cookies.put('crSideContactAnimationCounts', JSON.stringify(value), {'expires': cookie.expirationDate,'path' : '/'});
				} else if (animationCounts === 1) {
					date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0);

					var value = {
						value: animationCounts,
						expirationDate: date
					};

					$cookies.put('crSideContactAnimationCounts', JSON.stringify(value), {'expires': date,'path' : '/'});
				}

				return animationCounts;
			};

			var __setForm = function(data, contactBtn) {
				var _header = angular.element(element[0].querySelector('.w_side_contact_content .form_container .header'));
				var _content = angular.element(data.content);
				_content = angular.element($(_content[0]).getElement('.w_popup_body')).html();
				contactBtn.formContent = _content;

				// set the form
				_formContentWrapper.html(_content);
				// console.log('__setForm');

				scope.setFormHeader(contactBtn);
				$compile(_formContentWrapper)(scope);

				contactBtn.blimpForm = new Blimp.Form(null, {
					build: function(blimp_form) {
						if (Blimp.Form.instances && Blimp.Form.instances.contains(blimp_form)) {
							return;
						}

						blimp_form._element = $(_formContainer[0]);
						blimp_form.post_process();

						Blimp.Form.instances.include(blimp_form);

						var _encrypted = blimp_form._element.getElements('.encrypted');
						if(_encrypted && _encrypted.length > 0) {
							_encrypted.each(function(el){
								Core.add_encrypted_link(el);
							});
						}
					},

					onFormSuccess: function(context, data) {
						scope.showCloseBtn = true;
						$timeout(function() {
							var successMessage = angular.element(document.querySelector('.w_popup_success_message'));
							var _regBtns = angular.element(document.querySelectorAll('.w_popup_success_message .join_now'));

							if (_regBtns.length) {
								angular.forEach(_regBtns, function(el) {
									var btn = angular.element(el);
									btn.on('click', function(ev) {
										if (ev && ev.stop) ev.stop();

										var url = btn.attr('data-href');

										if (url) {
											__getRegistrationForm(url, successMessage);
										}
									});
								});
							}
						}, 100);
					},
					onFormFail: function(blimp, data) {
						$timeout(function() {
							scope.handleErrors(scope.form, data)
						});
					},
					post_process_build: false,
					replace_by_result: false,
					auto_hide_form: false,
					show_veil: true,
					action: 'ContactWidget',
					label: 'Contact Finish',
					eventCategory: scope.eventCategory
				});

				element.addClass('_on_form_state');
			};


			scope.onFieldChange = function() {
				scope.fieldName = scope.getFieldname();
				// if the form is not valid then remove the backend error associated to the field
				if (scope.form[scope.fieldName] && !scope.form[scope.fieldName].$valid) {
					scope.form[scope.fieldName].$setValidity('phoneShort', true);
					scope.form[scope.fieldName].$setValidity('phoneLong', true);
					scope.form[scope.fieldName].$setValidity('pattern', true);
					scope.form[scope.fieldName].$setValidity('required', true);
					scope.form[scope.fieldName].$setValidity('phoneExist', true);
				}
			};

			scope.handleErrors = function(form, data) {
				scope.fieldName = scope.getFieldname();

				if (!scope.fieldName) {
					return;
				}

				var errors = data;
				var hasError = false;
				if (errors) {
					angular.forEach(errors, function(error, key) {
						if (key == 'RPCFormReusableContact_dayphone' || key == 'FormRegistrationPopup_phone') {
							if (error[0].indexOf('already exist') > 0 || error[0].indexOf('already in use') > 0 ) {
								form[scope.fieldName].$setValidity('phoneExist', false);
							} else if (error[0].indexOf('too short') > 0) { // phone too short
								form[scope.fieldName].$setValidity('phoneShort', false);
							} else if (error[0].indexOf('too long') > 0) { // phone too long
								form[scope.fieldName].$setValidity('phoneLong', false);
							} else if (error[0].indexOf('incorrect') > 0) { // twilio phone error
								form[scope.fieldName].$setValidity('pattern', false);
							} else if (error[0].indexOf('required') > 0) { // phone required
								form[scope.fieldName].$setValidity('required', false);
							}

							hasError = true;
						}
					});

					if (!hasError) {
						scope.onFieldChange();
					}

					form.$setSubmitted();
				}
			};

			var __displayForm = function(contactBtn) {
				element.addClass('_on_form_state');
				var _successMsg = angular.element(document.querySelector('.w_popup_success_message'));
				var _regForm = angular.element(document.querySelector('#FormRegistrationPopup'));

				if (_successMsg.length || _regForm.length) {
					if (_successMsg.length) {
						_successMsg.remove();
					}

					if (_regForm.length) {
						_regForm.parent().remove();
					}
				}

				if (contactBtn) {
					_formContentWrapper.empty();
					_formContentWrapper.append(contactBtn.blimpForm._form_wrapper);
					$compile(_formContentWrapper)(scope);

					scope.setFormHeader(contactBtn);
				}
			};

			scope.getFieldname = function () {
				var input = angular.element(element[0].querySelector('.w_side_contact_content .cr-country-dropdown input'));

				if (!input.length) {
					return null;
				}

				return input.attr('name');
			};

			scope.getForm = function($event, index) {
				var contactBtn = scope._button;
				if (index) {
					contactBtn = angular.element(scope._buttons[index]);
				}

				if (contactBtn[0].blimpForm) {
					__displayForm(contactBtn[0]);

					return;
				}

				var url = contactBtn.attr('data-rpc').replace('#', '');
				$http({
					method: 'POST',
					url: url,
					headers: {'X-Requested-With': 'XMLHttpRequest'}
				}).success(function(data) {
					if (data) {
						__setForm(data, contactBtn[0]);
					}
				}).error(function() {});
			};

			scope.hideForm = function() {
				if (scope.onDefaultFormState) {
					if (!scope.onListingPopup) {
						scope.showCloseBtn = false;
					}
					__displayForm(scope._button[0]);
					return;
				}

				element.removeClass('_on_form_state');
				scope.onRegistrationForm = false;
				scope.onRegistrationMessage = false;
			};

			__getContent();

			scope.setFormHeader = function(contactBtn) {
				if (!contactBtn) {
					return;
				}

				var btn = angular.element(contactBtn);

				scope.agentName = btn.attr('data-form-header-text');
			};

			scope.submit = function(ev) {
				if (ev) {
					ev.stopPropagation();
					ev.preventDefault();
				}

				window.crRecaptcha.execute(function(){ scope.submitContactCaptcha()});
			};

			scope.submitContactCaptcha = function() {
				for (var i = 0; i < scope._buttons.length; i++) {
					if(scope._buttons[i].blimpForm) {
						scope._buttons[i].blimpForm.handle_form_submit(scope.eventCategory);
					}
				}
			};

			// predev side contact
			if (attrs.type === 'predev') {
				var content = angular.element(element[0].querySelector('.w_form'));
				var data = {
					content: content
				};
				__setForm(data, scope._button);
			}

			if (scope.onDefaultFormState) {
				scope.setFormHeader(scope._button[0]);
				scope.getForm();
				element.addClass('_no_animation');

				if (!scope.onListingPopup) {
					scope.showCloseBtn = false;
				} else {
					scope.showCloseBtn = true;
				}
			} else {
				scope.showCloseBtn = true;
				_defaultContent.css('display', 'block');
				element.addClass('_show_contact');
			}

			var __getRegistrationForm = function(url, successMessage) {
				$http({
					method: 'POST',
					url: url.replace('#', ''),
					headers: {'X-Requested-With': 'XMLHttpRequest'}
				}).success(function(data) {
					if (data) {
						__setRegistrationForm(data, successMessage);
					}
				}).error(function() {});
			};

			var __setRegistrationForm = function(data, successMessage) {
				var _regPopup = angular.element('<div>' + data.content + '</div>');

				var _regFormWrapper = angular.element(_regPopup[0].getElement('#email_form'));

				if (_regFormWrapper) {
					successMessage.remove();
					$compile(_regFormWrapper)(scope);
					_formContentWrapper.empty();
					_formContentWrapper.append(_regFormWrapper);
					scope.onRegistrationForm = true;
					scope.onRegistrationMessage = false;
					scope.user = {};

					var input = _regFormWrapper[0].getElement('input.button');
					var type;
					var args = [];
					if (input) {
						type = input.getAttribute('data-contact-type');
						args = ['_trackEvent', 'Registration', 'Contact-box-' + type, 'Submit'];
					}

					new Blimp.Form(null, {
						build: function(blimp_form) {
							if (Blimp.Form.instances && Blimp.Form.instances.contains(blimp_form)) {
								return;
							}
							blimp_form._element = $(_formContainer[0]);
							blimp_form.post_process();
							Blimp.Form.instances.include(blimp_form);
						},
						onFormSuccess: function(a, b) {
							if (args.length > 0) {
								_gaq.push(args);
							}
							scope.onRegistrationForm = false;
							scope.onRegistrationMessage = true;
							scope.$apply();
						},
						onFormFail: function(blimp, data) {
							$timeout(function() {
								scope.handleErrors(scope.form, data)
							});
						},
						post_process_build: false,
						replace_by_result: false,
						auto_hide_form: false,
						show_veil: true
					});
				}
			};
		}
	};
}]);
